import styled from '@emotion/styled'
// eslint-disable-next-line @nx/enforce-module-boundaries
import { colors as nightlyColors } from '../../../../../design-tokens/src/thenightly/colors'

export const StyledNavSectionLabel = styled.span({
    cursor: 'pointer',
    '&:hover': {
        color: nightlyColors.palette.starlight.default,
    },
})
